export const FALLBACK_IMAGES_COMMODITIES = [
  require("@/assets/images/news/commodities/global-connection.jpeg"),
  require("@/assets/images/news/commodities/news.jpeg"),
  require("@/assets/images/news/commodities/women-looking-stock.jpeg"),
  require("@/assets/images/news/commodities/online-news.png"),
  require("@/assets/images/news/commodities/report-gm.png"),
  require("@/assets/images/news/commodities/futuristic-technology.png"),
  require("@/assets/images/news/commodities/bull-and-bear.png"),
  require("@/assets/images/news/commodities/financial-graph.png"),
  require("@/assets/images/news/commodities/crisis-in-news.png"),
  require("@/assets/images/news/commodities/digital-marketing.png"),
];

export const FALLBACK_IMAGES_CURRENCIES = [
  require("@/assets/images/news/currencies/american-dollar-symbol.png"),
  require("@/assets/images/news/currencies/coins-stack.png"),
  require("@/assets/images/news/currencies/double-explosure1.png"),
  require("@/assets/images/news/currencies/dollars-connecting.png"),
  require("@/assets/images/news/currencies/dollar-seedling-growth.png"),
  require("@/assets/images/news/currencies/businessman-is-stacking.png"),
  require("@/assets/images/news/currencies/percentage-sign.png"),
  require("@/assets/images/news/currencies/businesswoman-use-laptop.jpeg"),
  require("@/assets/images/news/currencies/businessman-collecting.jpeg"),
  require("@/assets/images/news/currencies/stack-of-silver.jpeg"),
];

export const ALL_FALLBACK_IMAGES = [
  ...FALLBACK_IMAGES_COMMODITIES,
  ...FALLBACK_IMAGES_CURRENCIES,
];
